import { useState, useEffect, useRef } from 'react';
import "swiper/css";
import "swiper/css/effect-fade";
import { List, Grid } from 'lucide-react'; // Import list and grid icons
import Navbar from '../Components/Navbar';
import slidesData from '../Lib/slidesData';
import BlogGrid from '../Components/Blog/BlogGrid';
import BlogList from '../Components/Blog/BlogList'; // Import the new BlogList component
import '../styles/Blog.css';
import PageSwiper from '../Components/PageSwiper';
import PageLoader from '../Components/PageLoader';

const Blog = () => {
  const [loading, setLoading] = useState(true);
  const [isGridView, setIsGridView] = useState(true); // State to toggle view

  const aboutRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div>
      <Navbar scrollToAbout={scrollToAbout} />
      <PageSwiper slidesData={slidesData} />
      <main>
        <div ref={aboutRef}></div>
        <div className="flex justify-end items-center px-4 py-2">
          <List
            size={24}
            className={`cursor-pointer ${!isGridView ? 'text-green-500' : 'text-gray-500'}`}
            onClick={() => setIsGridView(false)}
          />
          <Grid
            size={24}
            className={`cursor-pointer ${isGridView ? 'text-green-500' : 'text-gray-500'}`}
            onClick={() => setIsGridView(true)}
          />
        </div>
        {isGridView ? <BlogGrid /> : <BlogList />}
      </main>
    </div>
  );
}

export default Blog;
